/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:991px){.user-settings-container[_ngcontent-%COMP%]   .bottombar[_ngcontent-%COMP%]{min-height:unset;padding-bottom:0}}.user-settings-container[_ngcontent-%COMP%]     .notification-setting-form{width:65%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/account-setting/user-settings/user-settings.component.scss.shim.ngstyle.js.pre-build-optimizer.js